module.exports = __webpack_public_path__ + "img/inBan_smal_img02.28c381a7.png";